import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "search-switch__box" }

import { nextTick, ref } from 'vue';
import CleanInput from '@/components/inputs/CleanInput.vue';
import IconMagnifier from '@/components/icons/Magnifier.vue';
import Delete from '@/components/icons/Delete.vue';

interface Props {
  value?: string;
  placeholder?: string;
  useInputEvent?: boolean;
  isNotFound?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchSwitch',
  props: {
    value: { default: '' },
    placeholder: { default: 'search' },
    useInputEvent: { type: Boolean, default: false },
    isNotFound: { type: Boolean, default: false }
  },
  emits: ["search", "input"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const input = ref();
const isActive = ref(false);
const searchRequest = ref();

const switchMobileInput = () => {
  isActive.value = true;
  nextTick(() => {
    input.value.$el.focus();
  });
};

const handleInput = (val: string) => {
  searchRequest.value = val;
  emit('input', val);
};

const cleanSearchInput = () => {
  input.value?.$el.focus();
  searchRequest.value = '';
  emit('input', '');
};

const handleSearch = () => {
  const val = input.value?.$el.value;
  emit('search', val);
};

const blurSearchInput = () => {
  if (searchRequest.value) {
    return false;
  }
  isActive.value = false;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["search-switch", { 'active': isActive.value, 'error': _ctx.isNotFound }])
    }, [
      _createElementVNode("div", {
        class: "search-switch__find",
        onClick: switchMobileInput
      }, [
        _createVNode(IconMagnifier)
      ]),
      _createVNode(CleanInput, {
        ref_key: "input",
        ref: input,
        value: searchRequest.value,
        placeholder: _ctx.placeholder,
        class: "search-switch__input",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.useInputEvent ? handleInput($event) : undefined)),
        onKeyup: _withKeys(handleSearch, ["enter"]),
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (isActive.value = true)),
        onBlur: blurSearchInput
      }, null, 8, ["value", "placeholder"]),
      (searchRequest.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "search-switch__clean",
            onClick: cleanSearchInput
          }, [
            _createVNode(Delete)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "search-switch__line" }, null, -1))
  ]))
}
}

})